import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InputType } from 'dg-input-lib';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { Response } from 'src/app/digigov/models/response.model';
import { Router } from '@angular/router';
import { MatTabGroup } from '@angular/material/tabs';
import { MaterialModule } from 'src/app/material.module';
import { TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import { CaseView } from '../../correspondence/models/correspondence-details.model';
import { DialogDataDgRuleDialog } from 'src/app/digigov/dg_components/dg-create-rule/dg-create-rule.component';
import { A } from '@angular/cdk/keycodes';

export class customData {
  selectedData: CaseView[];

  caseData: { row: { fileId: number; corrNo: string } };
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-to-mail',
  templateUrl: './to-mail.component.html',
  styleUrls: ['./to-mail.component.scss'],
})
export class ToMailComponent implements OnInit {
  mail = new FormGroup({
    to: new FormControl(null),
    cc: new FormControl(null),
    subject: new FormControl(null),
    content: new FormControl(null),
  });

  @Input() to;
  response: string;
  // value: Value;
  @Input() caseData: any;
  fileId: string;
  appTypeId: string;
  paramsone: any;
  selectedData = [];
  corrId: string;
  year: string;
  good: any = [];
  @Input() caseDataArray;
  constructor(
    private http: HttpClient,
    public translate: TranslateService,
    private router: Router,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ToMailComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public data1: customData,
    private appInitService: AppInitService
  ) {}

  // selectedEmployees: unknown;
  // selectedEmployees2: unknown;
  selectedEmployeeList: any = [];
  selectedOrganization: unknown;

  //doc_url = DOC_URL+"/components/DgEmployeeSearchComponent.html";
  @ViewChild('emp', { static: false }) emp: DgEmployeeSearchComponent;

  doc_url;
  empConfig = {
    multiSelect: true,
    header: 'Submit',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };

  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'true',
    multiselect: false,
    header: 'Organization Search',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };
  ngAfterViewInit(): void {}
  ngOnInit(): void {
    console.log('dialogDataaaaaaaaaaaaaaaaaaaaaaaaa', this.data1);
    this.mail?.controls['to']?.disable();
    this.mail?.controls['to']?.setValue(this.data.emailId);
    console.log('to', this.to);

    this.doc_url =
      this.appInitService?.appConfig?.dgDocUrl +
      '/components/DgEmployeeSearchComponent.html';
  }
  getData2(resp: any): void {
    this.selectedOrganization = JSON.stringify(resp);

    console.log('data in emp-search test', resp);
    this.year = resp[0].POST_ID;
    // this.good = this.year;
  }
  close() {
    this.router.navigateByUrl('main/outbox-files');
  }
  Send() {
    if (this.data.data1[0].appTypeId == 1) {
      const dataForPost = {
        fileId: this.data.data1[0].docId,
        appTypeId: 1,
        caseNo: this.data.data1[0].docNo,
        // corrNo: this.caseDataArray.corrNo,
        to: this.to,
        CC: this.year,
        Subject: this.mail?.controls['subject']?.value,
        content: this.mail?.controls['content']?.value,
      };
      this.http
        .post('/case-mgmnt/send-reminder', dataForPost)
        .subscribe((res: any) => {
          console.log(' reminder', res);
          let temp = res.data;
          this.dialogRef.close(true);
        });
    } else {
      const dataForPost = {
        corrId: this.data.data1[0].docId,
        appTypeId: 3,
        corrNo: this.data.data1[0].docNo,
        // corrNo: this.caseDataArray.corrNo,
        to: this.to,
        CC: String(this.year),
        Subject: this.mail?.controls['subject']?.value,
        content: this.mail?.controls['content']?.value,
      };
      this.http
        .post('/case-mgmnt/send-reminder', dataForPost)
        .subscribe((res: any) => {
          console.log(' reminder', res);
          let temp = res.data;
          this.dialogRef.close(true);
        });
    }
  }
}

//       For Files:
// {
// fileId : 123,
// appTypeId: 1,
// cc: [{empId: 123}],
// content: "testcontent"
// subject : "testsubject"
// }

// For Corr:
// {
// corrNo: 123,
// appTypeId:3,
// cc: [{empId: 123}],
// content: "testcontent"
// subject : "testsubject"
// }
